import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";
const VMRDALandWaltairUplands = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  // const images = [
  //   "/images/vlcsnap-2025-03-18-11h14m12s794.png",
  // ];

  const pricingData = [
    {
      id: 1,
      purpose:
        "Birthday functions and other Official / Corporate meetings / Get-together functions / Marriage functions / engagements/ receptions. (General Public)",
      rent: 100000,
      deposit: 20000,
      gst: 19800,
      cleaning: 10000,
      total: 149800,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img src={item.url} alt={`VMRDA Land Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>VMRDA Land in T.S.No.1011/1A1A2 & 1011/1A1A3A</h1>
                  <p>Ideal Venue for Corporate and Social Functions</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Venue Details */}
        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>VMRDA Land at Waltair Uplands</strong> is a prime location
            near the Viswa Priya Function Hall. It is ideal for hosting large
            functions including birthday parties, corporate meetings, social
            gatherings, marriages, engagements, and receptions. The venue offers
            a vast open area suitable for grand events.
          </p>

          {/* Pricing Section */}
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Cleaning Charges:{" "}
                  <strong>{item.cleaning.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Contact Section */}
          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Waltair Uplands (APIIC grounds),
              Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@vmrdaland.com
            </p>
          </div>

          {/* Book Now Button */}
          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VMRDALandWaltairUplands;
